import {
    Button,
    DataTable,
    DataTableCell,
    DataTableCustomComponent,
    DataTableRow,
    IconPlus,
    Page,
    Pill,
    Spinner
} from '@7shifts/sous-chef';
import DeleteCompanyFeatureModal from 'adminPanel/modules/Companies/components/DeleteCompanyFeatureModal/DeleteCompanyFeatureModal';
import { useFeatureFlag } from 'adminPanel/modules/Companies/hooks/useFeatureFlag';
import { CompanyFeature } from 'adminPanel/types';
import { __ } from 'i18n/translate';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import AddCompanyToFeatureModal from '../components/AddCompanyToFeatureModal/AddCompanyToFeatureModal';

const FeatureFlagPage = () => {
    const [showAddCompanyModal, setShowAddCompanyModal] = useState(false);
    const params = useParams();
    const featureFlagId = params.featureFlagId as string;

    const { featureFlag, isLoading, refetch } = useFeatureFlag(+featureFlagId);

    if (isLoading || !featureFlag) {
        return <Spinner block />;
    }

    return (
        <Page
            title={`${__('adminpanel.featureFlag')}: ${featureFlag.key}`}
            subtitle={__('adminpanel.companiesUsingFeatureFlag')}
            breadcrumbs={__('adminpanel.featureFlags')}
            actions={
                <Button
                    theme="primary"
                    onClick={() => setShowAddCompanyModal(true)}
                >
                    <IconPlus />
                    Adicionar empresas
                </Button>
            }
        >
            <DataTable
                items={featureFlag.companyFeatures}
                isLoading={isLoading}
                itemComponent={(props) => (
                    <FeatureFlagRow
                        {...props}
                        refetch={refetch}
                        featureId={+featureFlagId}
                    />
                )}
                columns={[
                    {
                        name: 'id',
                        label: '#ID',
                        size: 0.2
                    },
                    {
                        name: 'key',
                        label: 'Empresa',
                        size: 2
                    },
                    {
                        name: 'isEnabled',
                        label: 'Status',
                        size: 1
                    }
                ]}
                showActionMenu
            />
            {showAddCompanyModal && (
                <AddCompanyToFeatureModal
                    onClose={() => setShowAddCompanyModal(false)}
                    featureFlagCompanies={featureFlag.companyFeatures}
                    featureFlagId={+featureFlagId}
                    onSuccess={refetch}
                />
            )}
        </Page>
    );
};

type CFeatureFlagRowProps = DataTableCustomComponent<CompanyFeature> & {
    refetch: () => void;
    featureId: number;
};
const FeatureFlagRow = ({ item, refetch, featureId }: CFeatureFlagRowProps) => {
    const [isDeleting, setIsDeleting] = useState(false);
    return (
        <>
            <DataTableRow
                actions={[
                    {
                        action: 'remove',
                        label: __('main.delete'),
                        onAction: () => {
                            setIsDeleting(true);
                        }
                    }
                ]}
            >
                <DataTableCell columnIndex={0}>{item.company.id}</DataTableCell>
                <DataTableCell columnIndex={1}>
                    {item.company.name}
                </DataTableCell>
                <DataTableCell columnIndex={2}>
                    <Pill theme="success">{__('adminpanel.active')}</Pill>
                </DataTableCell>
            </DataTableRow>
            {isDeleting && (
                <DeleteCompanyFeatureModal
                    companyId={+item.company.id}
                    featureId={featureId}
                    onClose={() => setIsDeleting(false)}
                    onSuccess={refetch}
                />
            )}
        </>
    );
};

export default FeatureFlagPage;
